import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Icon, Image } from '@/ui'

interface MobileMenuProps {
  className?: string
  onClick: () => void
  onKeyDown: () => void
  isOpen: boolean
}

export const MobileMenu = ({
  className,
  onClick,
  onKeyDown,
  isOpen,
}: MobileMenuProps) => {
  const handleClick = () => {
    onClick()
  }

  const handleKeyDown = () => {
    onKeyDown()
  }

  return (
    <div
      className={`${className} flex items-center pointer`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="presentation"
    >
      <Icon icon={regular('bars')} color={isOpen ? 'white' : 'green'} />

      <Image
        src="https://heard-images.s3.amazonaws.com/assets/heard-h-logo.svg"
        className="ml-2"
        alt="Heard Logo"
        width={12.83}
      />
    </div>
  )
}
